import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, OnInit, ViewChild, } from '@angular/core';
import { LayoutConfigService } from './config/_core/services/layout-config.service';
import { ClassInitService } from './config/_core/services/class-init.service';


import { TranslationService } from './config/_core/services/translation.service';
import * as objectPath from 'object-path';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { PageConfigService } from './config/_core/services/page-config.service';
import { filter } from 'rxjs/operators';
import { SplashScreenService } from './config/_core/services/splash-screen.service';
import { AclService } from './config/_core/services/acl.service';
import { AuthenticationService } from './content/pages/auth/_core/services/authentication.service';
import { SessionKeys, TokenStorage } from './content/pages/auth/_core/services/token-storage.service';

// language list
import { locale as enLang } from './config/i18n/en';
import { locale as chLang } from './config/i18n/ch';
import { locale as esLang } from './config/i18n/es';
import { locale as jpLang } from './config/i18n/jp';
import { locale as deLang } from './config/i18n/de';
import { locale as frLang } from './config/i18n/fr';
import { environment } from '../environments/environment';
import { AuthService } from './content/pages/auth/_core/services/auth.service';
import { PermissionViewActionService } from './shared/services/permission-view-action.service';
import { PermissionNavigationService } from './shared/services/permission-navigation.service';

// LIST KNOWN ISSUES
// [Violation] Added non-passive event listener; https://github.com/angular/angular/issues/8866

@Component({
	// tslint:disable-next-line:component-selector
	selector: 'body[m-root]',
	templateUrl: './app.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements AfterViewInit, OnInit {
	title = 'Metronic';

	@HostBinding('style') style: any;
	@HostBinding('class') classes: any = '';

	@ViewChild('splashScreen', { read: ElementRef })
	splashScreen: ElementRef;
	splashScreenImage: string;
	private intervalRefreshToken = null;

	constructor(
		private layoutConfigService: LayoutConfigService,
		private classInitService: ClassInitService,
		private sanitizer: DomSanitizer,
		private translationService: TranslationService,
		private router: Router,
		private pageConfigService: PageConfigService,
		private splashScreenService: SplashScreenService,
		private aclService: AclService,
		private authenticationService: AuthenticationService,
		private tokenStorage: TokenStorage,
		private authService: AuthService,
		private permissionViewActionService: PermissionViewActionService,
		private permissionNavigationService: PermissionNavigationService
	) {
		// subscribe to class update event
		this.classInitService.onClassesUpdated$.subscribe(classes => {
			// get body class array, join as string classes and pass to host binding class
			setTimeout(() => this.classes = classes.body.join(' '));
		});

		this.layoutConfigService.onLayoutConfigUpdated$.subscribe(model => {
			this.classInitService.setConfig(model);

			this.style = '';
			if (objectPath.get(model.config, 'self.layout') === 'boxed') {
				const backgroundImage = objectPath.get(model.config, 'self.background');
				if (backgroundImage) {
					this.style = this.sanitizer.bypassSecurityTrustStyle('background-image: url(' + objectPath.get(model.config, 'self.background') + ')');
				}
			}

			// splash screen image
			this.splashScreenImage = objectPath.get(model.config, 'loader.image');
		});

		// register translations
		this.translationService.loadTranslations(enLang, chLang, esLang, jpLang, deLang, frLang);

		// override config by router change from pages config
		this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe((event: NavigationEnd) => {
				if(this.permissionNavigationService.get() != null) {
					this.permissionNavigationService.loadViewAction(event.url);
				}
				this.layoutConfigService.setModel({ page: objectPath.get(this.pageConfigService.getCurrentPageConfig(), 'config') }, true);
			});
	}

	ngOnInit(): void {
		this.intervalRefreshToken = setInterval(() => {
			if (this.authService.isLoggedIn()) {
				this.authService.refreshToken().subscribe(() => { });
			}
		}, environment.timeToRefreshToken)
	}

	ngAfterViewInit(): void {
		if (this.splashScreen) {
			this.splashScreenService.init(this.splashScreen.nativeElement);
		}
	}

	ngOnDestroy(): void {
		if (this.intervalRefreshToken != null) {
			this.intervalRefreshToken.clearInterval();
		}
	}
}
